















































































































































































































































































































































import { Component, Vue, Watch } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import * as _ from "lodash";
import {
  ContactInformation,
  FetchState,
  HsabSsoDestination,
  LoginMethod,
  maritalStatusDisplayMap,
  FamilyMember,
  FamilyMemberRelationship,
  FamilyMemberStatus,
EmployerEmployeeProfileSettingValue
} from "@/shared/types";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserPlanStore } from "@/employee/store/userPlan";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useThemeStore } from "@/shared/store/theme";
import { useUserStore } from "@/shared/store/user";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useFamilyStore } from "@/employee/store/family";
import DependentTableView from "@/employee/components/settings/DependentTableView.vue";
import EditDependent from "@/employee/components/settings/EditDependent.vue";
import EditProfile from "@/employee/components/settings/profile/EditProfile.vue";
import AccountInfoTabs from "@/employee/components/settings/profile/AccountInfoTabs.vue";

const initialState: ContactInformation = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  isMailingSameAsPhysical: false,
  dateOfBirth: "",
  mailingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  physicalAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  lastFourSsn: "",
  memberNumber: "",
  lastLogin: "",
  username: ""
};

const passwordInitialState = {
  currentPassword: "",
  newPassword: "",
  newPasswordVerify: ""
};

const emptyDependentModel: FamilyMember = {
  id: 0,
  firstName: "",
  lastName: "",
  tag: "",
  dateOfBirth: "",
  debitCardHolder: false,
  relationship: FamilyMemberRelationship.Dependent,
  ssn: "",
  status: FamilyMemberStatus.Active
};

const editProfileDisabledMessage = "Editing has been disabled by your employer. Please contact your employer directly to make changes.";

@Component({
  components: {
    NoAccountMessage,
    Input,
    SettingsNavigation,
    SettingsHeader,
    GenericLoadingSpinner,
    SsoDeepLink,
    DependentTableView,
    EditDependent,
    EditProfile,
    AccountInfoTabs
  }
})
export default class MyProfileDisplay extends Vue {
  $validator: Validator;

  userBankAccountStore = useUserBankAccountStore();
  themeStore = useThemeStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userPlanStore = useUserPlanStore();
  contactInfoStore = useContactInfoStore();
  partnerPortal = usePartnerPortalStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  featureFlagStore = useFeatureFlagStore();
  familyStore = useFamilyStore();

  isBankMasked = true;
  formModel: ContactInformation = { ...initialState };
  isSubmitting = false;
  showEmailChangeModal = false;
  editEmailMode = false;
  editUsernameMode = false;
  updatingUsername = false;
  passwordFormModel = { ...passwordInitialState };
  editPasswordMode = false;
  updatingPassword = false;
  showPasswordRequirements = false;
  maritalStatusDisplayMap = maritalStatusDisplayMap;
  editProfileDisabledMessage = editProfileDisabledMessage;
  editDependentParameters = {
    show: { value: false },
    dependent: { ...emptyDependentModel },
    onSave: this.onSaveDependent,
    toggleClose: this.closeEditDependentForm,
    isNew: true
  };
  editProfileParameters = {
    show: { value: false },
    contactInfo: { ...initialState },
    onSave: this.onSaveProfile,
    toggleClose: this.closeEditProfileForm
  };

  mounted (): void {
    this.userPlanStore.getPlanType();
    this.contactInfoStore.getContactInformation();
    this.initializeFromStateValue();
    this.partnerPortal.getPartnerPortalStatus();
    this.userBankAccountStore.loadBankAccountState();
    if (this.consumerFieldsEnabled) {
      this.familyStore.initialize();
    }
  }

  get bankAccountLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded;
  }

  get showBankAccount () {
    return this.bankAccountLoaded && this.userBankAccountStore.accountNumber;
  }

  get isFormLocked () {
    return !this.partnerPortal.hasActiveAccount && !this.userStore.isNotionalDashboardActive;
  }

  get bankAccount () {
    if (this.bankAccountLoaded && this.isBankMasked) {
      return "•".repeat(this.userBankAccountStore.accountNumber.length);
    }

    return this.userBankAccountStore.accountNumber;
  }

  get hsabSsoDeeplinkProfileSummary () {
    return HsabSsoDestination.ProfileSummary;
  }

  get newPasswordVerifyValidation () {
    return {
      required: !!this.passwordFormModel.newPassword,
      confirmed: !!this.passwordFormModel.newPasswordVerify && this.passwordFormModel.newPassword
    };
  }

  get canManageCredentials () {
    return this.userStore.loginMethod !== LoginMethod.Sso;
  }

  get userHasHsaAccount () {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  get consumerFieldsEnabled () {
    return this.featureFlagStore.flags.bend17254EnableProfileConsumerFields;
  }

  get showUndeliverableAddressWarning () {
    return this.consumerFieldsEnabled && this.formModel.mailingAddress.isUndeliverable === true;
  }

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  get showHsabSsoDeeplinkProfileEditButton () {
    return this.custodianSettingsStore.isHsaBankCustodian && !this.profileAddEditEnabled;
  }

  get dependents () {
    const supportedValues = [FamilyMemberRelationship.Spouse, FamilyMemberRelationship.Dependent];

    return this.familyStore
    .familyMembers
    .filter(x => supportedValues.includes(x.relationship));
  }

  get showDependents () {
    if (!this.consumerFieldsEnabled) {
      return false;
    }
    return this.familyStore.isFamilyStateLoaded;
  }

  get activeDependents () {
    return this.dependents.filter(x => x.status === FamilyMemberStatus.Active);
  }

  get hasActiveDependents () {
    return this.activeDependents && this.activeDependents.length > 0;
  }

  get inactiveDependents () {
    return this.dependents.filter(x => x.status === FamilyMemberStatus.Inactive);
  }

  get hasInactiveDependents () {
    return this.inactiveDependents && this.inactiveDependents.length > 0;
  }

  get allFieldEditSettings () {
    const fieldEditSettings = this.contactInfoStore.contactInformation.fieldEditSettings;

    if (!fieldEditSettings) {
      return [];
    }

    return [
      fieldEditSettings.emailAddress,
      fieldEditSettings.homePhone,
      fieldEditSettings.mailingAddress,
      fieldEditSettings.maritalStatus,
      fieldEditSettings.mobileNumber
    ];
  }

  get editProfileDisabled () {
    return !this.allFieldEditSettings.some(value => value === EmployerEmployeeProfileSettingValue.Edit);
  }

  togglePasswordRequirements () {
    this.showPasswordRequirements = !this.showPasswordRequirements;
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
  }

  @Watch("contactInfoStore.contactInformationState")
  initializeFromStateValue () {
    const contactInformation = this.contactInfoStore.contactInformation;
    if (this.contactInfoStore.contactInformationState === FetchState.Loaded && !contactInformation) {
      this.cloneToCurrentModel(initialState);
    } else if (contactInformation) {
      this.cloneToCurrentModel(contactInformation);
    }
  }

  @Watch("contactInfoStore.contactInformation")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }

  get isLoaded () {
    return this.contactInfoStore.contactInformationState === FetchState.Loaded;
  }

  toggleBankMask () {
    this.isBankMasked = !this.isBankMasked;
  }

  toggleEditEmail () {
    this.editEmailMode = !this.editEmailMode;
  }

  toggleEditUsername () {
    this.editUsernameMode = true;
  }

  toggleEditPassword () {
    this.editPasswordMode = true;
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    if (this.formModel.email === this.contactInfoStore.contactInformation.email) {
      return;
    }

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return;
        }

        this.contactInfoStore.saveContactInformation(this.formModel).then(() => {
          this.showEmailChangeModal = true;
        }).catch(() => {/* noop */});
      })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  closePopup () {
    this.showEmailChangeModal = false;
    this.editEmailMode = false;
  }

  updateUsername () {
    if (this.updatingUsername) {
      return;
    }

    if (this.formModel.username === this.contactInfoStore.contactInformation.username) {
      this.editUsernameMode = false;
      return;
    }

    this.updatingUsername = true;

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return Promise.reject();
        }

        return this.contactInfoStore.updateUserIdpUsername(this.formModel.username);
      })
      .then(() => {
        this.contactInfoStore.getContactInformation();
        this.editUsernameMode = false;
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.updatingUsername = false;
      });
  }

  updatePassword () {
    if (this.updatingPassword) {
      return;
    }

    this.updatingPassword = true;

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return Promise.reject();
        }

        return this.contactInfoStore.updateUserIdpPassword({
          currentPassword: this.passwordFormModel.currentPassword,
          newPassword: this.passwordFormModel.newPassword
        });
      })
      .then(() => {
        this.editPasswordMode = false;
        this.passwordFormModel = { ...passwordInitialState };
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.updatingPassword = false;
      });
  }

  cancelUsernameUpdate () {
    this.updatingUsername = false;
    this.editUsernameMode = false;
    this.formModel.username = this.contactInfoStore.contactInformation.username;
  }

  cancelPasswordUpdate () {
    this.updatingPassword = false;
    this.editPasswordMode = false;
    this.passwordFormModel = { ...passwordInitialState };
    this.showPasswordRequirements = false;
  }

  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);

    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }

  showEditDependentForm () {
    this.editDependentParameters.dependent = { ...emptyDependentModel };
    this.editDependentParameters.show.value = true;
  }

  onSaveDependent () {
    return this.familyStore.addFamilyMember(this.editDependentParameters.dependent)
      .then(() => {
        this.editDependentParameters.show.value = false;
      })
      .catch(() => {/*noop*/});
  }

  closeEditDependentForm () {
    this.editDependentParameters.show.value = false;
  }

  showEditProfileForm () {
    this.editProfileParameters.contactInfo = _.cloneDeep(this.formModel);
    this.editProfileParameters.show.value = true;
  }

  onSaveProfile () {
    return this.contactInfoStore.saveProfile(this.editProfileParameters.contactInfo)
      .then(() => {
        this.editProfileParameters.show.value = false;
      })
      .catch(() => {/*noop*/});
  }

  closeEditProfileForm () {
    this.editProfileParameters.show.value = false;
  }
}
